<template>
    <a class="article item" :href="article.url" @click.prevent.stop="openArticle(article.slug)">
        <img :src="article.media[thumbnail_size].url" :alt="article.media[thumbnail_size].alt">
        <div class="article-body">
            <h2 class="article-title" v-html="article.title"></h2>
            <p class="article-content" v-html="article.description"></p>
            <footer class="article-info">
                <span>{{ article.formatted_date }}</span>
                <span>
                    <tags size="small" :categories="article.categories"></tags>
                </span>
            </footer>
        </div>
    </a>
</template>

<script>
    import Tags from "../article/tags.vue";
	import router from "../article/router";

    export default {
    	components: {
    	    Tags
        },
    	props: [
    		"article"
        ],
        data () {
			return {
				thumbnail_size: "medium"
			};
        },
        methods: {
			openArticle (slug) {
				router.push({ path: `/article/${slug}`})
			}
        }
    }
</script>

<style lang="scss" scoped>
    @import "article";
    $margin-small: 0rem;
    $margin: .80rem;
    .article.item {
        width: calc(100% - #{$margin-small * 2});
        margin: $margin-small;
        height: auto !important;
        display: block;
        img {
            width: 550px;
        }
    }
    @media screen and (min-width: 40em) {
        .article.item {
            margin: $margin;
            width: calc(50% - #{$margin * 2});
        }
    }

    @media screen and (min-width: 64em) {
        .article.item {
            width: calc(calc(100% / 3) - #{$margin * 2});
        }
    }
    .article.item {
        margin-bottom: 1rem;
    }
</style>


// WEBPACK FOOTER //
// news-common.vue?35a074bb